import {PricingModel} from 'src/openapi/admin/models/PricingModel';

import type {ContractDetails} from 'src/openapi/admin/models/ContractDetails';
import type {IntegrationContractDetailed} from 'src/openapi/admin/models/IntegrationContractDetailed';

export const getEndDate = (data: ContractDetails | IntegrationContractDetailed): string => {
    if (data.contractInfo.pricingModel === PricingModel.INTEGRATION) {
        return data.contractInfo.endDate || '';
    }

    if (data.contractInfo.pricingModel === PricingModel.SUBSCRIPTION) {
        return data.contractInfo.endDate || '';
    }

    return '';
};
